"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovableButtonWrapper = exports.approvableButtonSlice = exports.doApprove = exports.doGetApproval = exports.approvalKey = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const types_1 = require("types");
const ApiClient_1 = require("../clients/ApiClient");
const ChainEventItem_1 = require("./ChainEventItem");
const unifyre_extension_sdk_1 = require("unifyre-extension-sdk");
function mapStateToProps(state) {
    return state.data.approval;
}
function approvalKey(userAddress, contractAddress, currency) {
    return `${userAddress}|${contractAddress}|${currency}`;
}
exports.approvalKey = approvalKey;
exports.doGetApproval = toolkit_1.createAsyncThunk('approveButton/doGetApproval', async (payload, ctx) => {
    const { userAddress, contractAddress, currency } = payload;
    const api = types_1.inject(ApiClient_1.ApiClient);
    const allocation = await api.getContractAllocation(userAddress, contractAddress, currency);
    console.log('doGetApproval', payload, { allocation });
    if (!!allocation) {
        ctx.dispatch(exports.approvableButtonSlice.actions.allocationUpdated({
            contractAddress, userAddress, currency, allocation: allocation.allocation
        }));
    }
});
exports.doApprove = toolkit_1.createAsyncThunk('approveButton/doApprove', async (payload, ctx) => {
    const { userAddress, contractAddress, currency } = payload;
    const api = types_1.inject(ApiClient_1.ApiClient);
    const transactionId = await api.setContractAllocation(userAddress, contractAddress, currency);
    if (!!transactionId) {
        ctx.dispatch(exports.approvableButtonSlice.actions.approveTransactionReceived({ transactionId }));
    }
});
exports.approvableButtonSlice = toolkit_1.createSlice({
    name: 'approvableButton',
    initialState: {
        approveTransactionId: '',
        pending: false,
        approvals: {},
    },
    reducers: {
        allocationUpdated: (state, action) => {
            const { userAddress, contractAddress, currency, allocation } = action.payload;
            state.approvals[approvalKey(userAddress, contractAddress, currency)] = allocation;
        },
        transactionFailed: (state, action) => {
            state.error = action.payload.message || 'Error while getting transaction';
            state.pending = false;
            state.status = 'failed';
        },
        transactionCompleted: (state, action) => {
            state.error = undefined;
            state.pending = false;
            state.status = 'completed';
        },
        approveTransactionReceived: (state, action) => {
            state.approveTransactionId = action.payload.transactionId;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(exports.doApprove.pending, (state, action) => {
            state.pending = true;
            state.error = undefined;
            state.approveTransactionId = '';
            state.status = 'pending';
        });
        builder.addCase(exports.doApprove.fulfilled, (state, action) => {
            state.pending = false;
            state.error = undefined;
            // state.status = 'completed';
        });
        builder.addCase(exports.doApprove.rejected, (state, action) => {
            state.pending = false;
            console.log('Error running approval', action.payload);
            state.error = (action.payload || {}).toString();
            state.status = 'failed';
        });
    }
});
async function updateEvent(dispatch, e) {
    try {
        const connect = types_1.inject(unifyre_extension_sdk_1.UnifyreExtensionKitClient);
        const t = await connect.getTransaction(e.id);
        console.log('Checking the transloota ', t);
        if (t && t.blockNumber) {
            console.log('Translo iso componte ', t);
            dispatch(exports.approvableButtonSlice.actions.transactionCompleted({ transactionId: e.id }));
            return Object.assign(Object.assign({}, e), { status: 'completed' }); // TODO: Check for failed
        }
        console.log('Noting inderezding ', e);
        return Object.assign(Object.assign({}, e), { status: 'pending' });
    }
    catch (ex) {
        console.error('ApprovableButton.updateEvent', ex, e);
        dispatch(exports.approvableButtonSlice.actions.transactionFailed({ message: ex.message }));
        return Object.assign(Object.assign({}, e), { status: 'failed' });
    }
}
function ApprovableButtonWrapper(ownProps) {
    const dispatch = react_redux_1.useDispatch();
    const props = react_redux_1.useSelector(mapStateToProps);
    const network = (ownProps.currency || '').split(' ')[0];
    const { userAddress, contractAddress, currency } = ownProps;
    const { status } = props;
    const currentApproval = props.approvals[approvalKey(userAddress, contractAddress, currency)];
    react_1.useEffect(() => {
        if (userAddress && contractAddress && currency && types_1.Utils.isCurrencyValid(currency)) {
            dispatch(exports.doGetApproval({ userAddress, contractAddress, currency }));
        }
    }, [userAddress, contractAddress, currency, status]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ChainEventItem_1.ChainEventItem, { id: props.approveTransactionId, network: network, initialStatus: 'pending', eventType: 'approval', updater: e => updateEvent(dispatch, e) },
            react_1.default.createElement(ownProps.View, { isApprovalMode: types_1.BigUtils.safeParse(currentApproval).lt(types_1.BigUtils.safeParse(ownProps.amount || '0.0001')), pendingApproval: props.status === 'pending', approvalTransactionId: props.approveTransactionId, onApproveClick: () => dispatch(exports.doApprove(Object.assign({}, ownProps))) }))));
}
exports.ApprovableButtonWrapper = ApprovableButtonWrapper;
//# sourceMappingURL=ApprovableButtonWrapper.js.map